module.exports = __webpack_public_path__ + "img/modal_logo.017dd826.png";